/**
 * Checks if we are rendering in a `react-native-webview` context.
 * We do that by checking if there's a `window.ReactNativeWebView.postMessage` function
 */
export function isReactNativeWebViewContext() {
    return (window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage);
}
/**
 * Post a typed editor message using `react-native-webview` function `window.ReactNativeWebView.postMessage`.
 * The message must be a raw string, so we first convert our message object to a JSON string using `JSON.stringify`.
 * The message must be parsed back by the `react-native-webview` client.
 */
export function postMessage(message) {
    postRawMessage(JSON.stringify(message));
}
/**
 * Post a raw string message using `react-native-webview` function `window.ReactNativeWebView.postMessage`
 */
function postRawMessage(message) {
    if (isReactNativeWebViewContext()) {
        window.ReactNativeWebView.postMessage(message);
    }
}
